import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './OrderingBy.module.scss';
import chevron from "../../constants/images/chevron.svg";
import {orderingByCustomer} from "../../constants/orderingByCustomer";
import {filtersForCleanerActions} from "../../store/slices/filtersForCleanerSlice";
import {filtersForCustomerActions} from "../../store/slices/filtersForCustomerSlice";
import {orderingByCleaner} from "../../constants/orderingByCleaner";

const OrderingBy = ({type}) => {
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState(orderingByCustomer[0]?.name);

    const dispatch = useDispatch();
    const {orderingName: orderingNameCleaner} = useSelector(state => state.filtersForCleaner);
    const {orderingName: orderingNameCustomer} = useSelector(state => state.filtersForCustomer);

    const dropdownRef = useRef(null);

    //if the user click outside the dropdown, it closes
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpenDropdown(false);
        }
    };

    useEffect(() => {
        if (isOpenDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpenDropdown]);

    const handleSelectOption = (item) => {
        const {name, ordering} = item;
        setSelectedOption(name);

        if (!ordering) {
            dispatch(filtersForCleanerActions.clearFilters());
            dispatch(filtersForCustomerActions.clearFilters());
        }

        if (type === 'cleaner') {
            dispatch(filtersForCleanerActions.setOrdering({name, ordering}));
        } else if (type === 'customer') {
            dispatch(filtersForCustomerActions.setOrdering({name, ordering}));
        }

        setIsOpenDropdown(false);
    }

    return (
        <div className={styles.dropdown_wrapper} ref={dropdownRef}>
            <div
                onClick={() => setIsOpenDropdown(prev => !prev)}
                className={styles.dropdown_wrapper_button}
            >
                {type === 'cleaner' && <span>{!!orderingNameCleaner ? orderingNameCleaner : selectedOption}</span>}
                {type === 'customer' && <span>{!!orderingNameCustomer ? orderingNameCustomer : selectedOption}</span>}

                <img
                    className={styles.chevron}
                    src={chevron}
                    alt="chevron down icon"
                />
            </div>

            {isOpenDropdown &&
                <ul className={styles.dropdown_wrapper_options}>
                    {(type === 'customer' ? orderingByCustomer : orderingByCleaner).map((item, index) =>
                        <li
                            onClick={() => handleSelectOption(item)}
                            key={index}
                        >{item.name}</li>)}
                </ul>}
        </div>
    );
};

export default OrderingBy;
